<div class="mt-4 mb-4">
  <h3 class="text-lg font-semibold text-slate-900">Notificaciones a clientes</h3>
  <p class="text-sm text-slate-500">
    Correos automáticos que Pento envía al cliente final. En modo headless, el integrador hace llegar las ligas por su cuenta.
    @if (!canEdit) { Solo un administrador de Pento puede cambiar esta configuración. }
  </p>
</div>

@if (loading()) {
  <div class="flex justify-center py-6"><i class="pi pi-spin pi-spinner text-2xl text-sky-500"></i></div>
} @else if (loadError()) {
  <p class="text-sm text-red-600">{{ loadError() }}</p>
} @else {
  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-3" role="radiogroup" aria-label="Modo de notificaciones">
      @for (option of modes; track option.value) {
        <button
          type="button"
          role="radio"
          [attr.aria-checked]="mode() === option.value"
          [disabled]="!canEdit"
          (click)="selectMode(option.value)"
          class="text-left rounded-lg border px-4 py-3 transition-colors disabled:cursor-default enabled:hover:bg-slate-50"
          [class.border-sky-500]="mode() === option.value"
          [class.bg-sky-50]="mode() === option.value"
          [class.border-slate-200]="mode() !== option.value"
        >
          <span class="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <i class="pi" [class.pi-circle-fill]="mode() === option.value" [class.text-sky-600]="mode() === option.value"
              [class.pi-circle]="mode() !== option.value" [class.text-slate-400]="mode() !== option.value"></i>
            {{ option.label }}
          </span>
          <span class="block text-xs text-slate-500 mt-1">{{ option.description }}</span>
        </button>
      }
    </div>

    <div class="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
      <i class="pi pi-info-circle mt-0.5"></i>
      <span>Los envíos manuales y los avisos de mandatos siempre se realizan.</span>
    </div>

    @for (group of groups(); track group.category) {
      <div class="flex flex-col gap-2">
        <h4 class="text-sm font-semibold uppercase tracking-wide text-slate-500">{{ group.label }}</h4>
        <div class="flex flex-col divide-y divide-slate-100 rounded-lg border border-slate-200">
          @for (type of group.types; track type.name) {
            <div class="flex items-center justify-between gap-4 px-4 py-3">
              <div class="min-w-0">
                <label [for]="'notif-' + type.name" class="block text-sm font-medium text-slate-900">{{ type.label }}</label>
                <p class="text-xs text-slate-500 mt-0.5">{{ type.description }}</p>
              </div>
              <p-toggleswitch
                [inputId]="'notif-' + type.name"
                [ngModel]="isSent(type)"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="toggle(type, $event)"
                [disabled]="isLocked()"
              />
            </div>
          }
        </div>
      </div>
    }
  </div>
}
